import {withTranslation} from '@wix/yoshi-flow-editor'
import {isEditor, isMobile} from '../../../../../commons/selectors/environment'
import {isStillInIframe} from '../../selectors/environment'
import {getFirstEvent} from '../../selectors/events'
import {getComponentConfig, isRibbonVisible} from '../../selectors/settings'
import {
  getAlignment,
  getCompactHorizontalDividerHeight,
  getCompactHorizontalDividerWidth,
  getContentAlignment,
  getImagePosition,
  getImageWidth,
  getOneButtonWidth,
  getVerticalImagePosition,
  getWidgetLayout,
  isCompactDividerVisible,
  isDateEnabled,
  isHorizontalLayout,
  isImageVisible,
  isLocationEnabled,
  isOnImageLayout,
  isOnlyButtonVisible,
  isVerticalLayout,
} from '../../selectors/single-settings'
import {AppProps} from '../app/interfaces'
import {connect} from '../runtime-context/connect'
import {SingleEventOwnProps, SingleEventStateProps} from './interfaces'
import {SingleEvent as SingleEventPresentation} from './single-event'

const mapState = ({state, host: {dimensions}, isRTL}: AppProps): SingleEventStateProps => {
  const componentConfig = getComponentConfig(state)
  const event = getFirstEvent(state)

  return {
    event,
    layout: getWidgetLayout(componentConfig),
    alignment: getAlignment(componentConfig),
    verticalAlignment: getContentAlignment(componentConfig),
    showDate: isDateEnabled(componentConfig),
    showLocation: isLocationEnabled(componentConfig),
    compactDividerVisible: isCompactDividerVisible(state),
    compactDividerWidth: getCompactHorizontalDividerWidth(componentConfig),
    compactDividerHeight: getCompactHorizontalDividerHeight(componentConfig),
    buttonLayout: isOnlyButtonVisible(state),
    buttonWidth: getOneButtonWidth(state.component),
    onImageLayout: isOnImageLayout(state),
    horizontalLayout: isHorizontalLayout(componentConfig),
    verticalLayout: isVerticalLayout(componentConfig),
    imageVisible: isImageVisible(state),
    imageWidth: getImageWidth(componentConfig),
    imagePosition: getImagePosition(componentConfig),
    verticalImagePosition: getVerticalImagePosition(componentConfig),
    mobile: isMobile(state),
    editor: isEditor(state),
    height: dimensions.height,
    width: dimensions.width,
    rtl: isRTL,
    showRibbon: isRibbonVisible(state, event),
    stillInIframe: isStillInIframe(),
  }
}

export default connect<SingleEventOwnProps, SingleEventStateProps>(mapState)(withTranslation()(SingleEventPresentation))
